import { useTranslation } from 'react-i18next';

export const ContractStatusBadge = ({ contractStatus }) => {
  const { t } = useTranslation();
  const statusMap = {
    0: { label: t('APT'), colorClass: 'colorbk-success-strong' },
    1: { label: t('PART_APT'), colorClass: 'colorbk-warning-strong' },
    2: { label: t('UN_APT'), colorClass: 'colorbk-danger-strong' },
    3: { label: t('LOW'), colorClass: 'gray-700-bg' },
  };
  const statusConfig = statusMap[contractStatus] || { label: '-', colorClass: 'gray-400-bg' };

  return (
    <span className={`badge-status status-text white-color ${statusConfig.colorClass}`}>
      {statusConfig.label}
    </span>
  );
};
